export interface ITrainingCenterAddress {
  city: string;
  country: string;
  timeZone: string;
}

export class TrainingCenterAddress implements ITrainingCenterAddress {
  city: string;
  country: string;
  timeZone: string;

  constructor(clone: TrainingCenterAddress = null) {
    this.city = '';
    this.country = '';
    this.timeZone = '';

    if (clone) {
      this.city = clone.city;
      this.country = clone.country;
      this.timeZone = clone.timeZone;
    }
  }
}
